export const USAGE_FILL = {
  ok: "var(--green-600)",
  warn: "var(--orange-600)",
  critical: "var(--red-600)",
};

export function usageStatus(fraction: number): keyof typeof USAGE_FILL {
  if (fraction >= 0.9) return "critical";
  if (fraction >= 0.75) return "warn";
  return "ok";
}
